import React, { useState, useEffect } from 'react';
import { browserHistory } from 'react-router';
import MediaQuery from 'react-responsive';
import PropTypes from 'prop-types';
import isEmpty from 'lodash/isEmpty';

import SurveysResults from './SurveysResults';
import Icon from '../Icon';
import ContentArea from '../ContentArea';
import Content from '../ContentArea/Content';
import SurveyList from './SurveyList';
import SurveysDrawer from './SurveysDrawer';
import MobileNavbar from '../common/MobileNavbar';
import {
  ACTIONS,
  COMMON,
  PICK_ITEM_LEFT,
  SURVEYS_ANSWERED_EMPTY,
  SURVEYS_TITLE,
} from '../../constants/strings';
import { SURVEYS_LIST_TYPE } from '../../constants';
import { BREAKPOINT } from '../../constants/styles';
import { MESSAGES } from '../../constants/routes';
import { isDesktop } from '../../utils/mobileHelpers';
import { enhance } from './enhance';
import { usePageView } from '../../hocs/usePageView';
import MetaHelmet from '../AppHelmet/MetaHelmet';

const Surveys = ({
  fetchAnsweredSurveys,
  setTargetUserId,
  getUser,
  params: { contextId },
  profileData,
  intl: { formatMessage },
  fetchUpcomingSurveys,
  getAccessLevels,
  upcomingList,
  answeredList,
  loadNextUpcomingRequests,
  isProvider,
}) => {
  const [surveyListType, setSurveyListType] = useState(null);
  const [isShowOnlySurveyList, toggleContent] = useState(false);
  const [selectedSurveyId, setSelectedSurveyId] = useState(null);

  useEffect(() => {
    getUser({ id: contextId });

    if (contextId) {
      setTargetUserId({ id: Number(contextId) });
    }

    getAccessLevels({ id: contextId });

    fetchAnsweredSurveys({
      id: contextId,
      limit: 16,
    });

    fetchUpcomingSurveys({
      id: contextId,
      limit: 20,
    });
  }, []);
  usePageView('Profile | Surveys');

  const handleSurveyListClick = (type, id) => {
    if (id) setSelectedSurveyId(id);
    setSurveyListType(type);
    if (!isDesktop()) {
      toggleContent(true);
    }
  };

  const handleBack = () => {
    if (isShowOnlySurveyList) {
      setSurveyListType(null);
      toggleContent(false);
      return;
    }
    browserHistory.push(`/${MESSAGES}`);
  };

  const getShownSurveys = () => {
    switch (surveyListType) {
      case SURVEYS_LIST_TYPE.UPCOMING:
        return (
          <SurveyList
            listTitle={formatMessage(ACTIONS.survey.upcoming)}
            surveys={upcomingList}
            loadMore={loadMore}
            className="pa3"
          />
        );
      case SURVEYS_LIST_TYPE.RESULTS:
        return (
          <SurveysResults
            surveys={answeredList}
            openedSurveyId={selectedSurveyId}
            className="pa3"
          />
        );
      default:
        return getEmptyState();
    }
  };

  const getEmptyState = () => {
    const emptyStateText =
      isEmpty(upcomingList) && isEmpty(answeredList)
        ? SURVEYS_ANSWERED_EMPTY
        : PICK_ITEM_LEFT;

    return (
      <div styleName="empty-state">
        <Icon name="no-surveys" size={148} className="pb4" />
        <div styleName="empty-state__text">{formatMessage(emptyStateText)}</div>
      </div>
    );
  };

  const loadMore = () => {
    loadNextUpcomingRequests({
      id: contextId,
      limit: 10,
    });
  };

  const mobileButtonTitle = isShowOnlySurveyList
    ? formatMessage(SURVEYS_TITLE)
    : formatMessage(COMMON.back);

  return (
    <div className="Root">
      <MetaHelmet title="pages.title.surveys" />

      <div className="g-content" styleName="root">
        <MediaQuery maxWidth={BREAKPOINT}>
          <MobileNavbar openContext="arrow-down" toggleContext={handleBack}>
            <p children={mobileButtonTitle} />
          </MobileNavbar>
        </MediaQuery>
        <If condition={!isShowOnlySurveyList}>
          <SurveysDrawer
            contextId={contextId}
            isProvider={isProvider}
            profile={profileData}
            onBack={handleBack}
            onSurveyListClick={handleSurveyListClick}
            onSurveyResultsClick={handleSurveyListClick}
            surveyId={selectedSurveyId}
          />
        </If>
        <ContentArea className="relative">
          <Content>{getShownSurveys()}</Content>
        </ContentArea>
      </div>
    </div>
  );
};

Surveys.propTypes = {
  answeredList: PropTypes.array,
  upcomingList: PropTypes.array,
  profileData: PropTypes.object,
  getUser: PropTypes.func.isRequired,
  getAccessLevels: PropTypes.func.isRequired,
  fetchUpcomingSurveys: PropTypes.func.isRequired,
  intl: PropTypes.shape({
    formatMessage: PropTypes.func,
  }).isRequired,
  fetchAnsweredSurveys: PropTypes.func.isRequired,
  setTargetUserId: PropTypes.func.isRequired,
  params: PropTypes.object.isRequired,
  loadNextUpcomingRequests: PropTypes.func.isRequired,
  isProvider: PropTypes.bool,
};

export default enhance(Surveys);



// WEBPACK FOOTER //
// ./src/components/Surveys/index.jsx